import { Link, Navigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { usePlansQuery } from '@/generated/graphql';

const CouponLanding = () => {
  const { t } = useTranslation();
  const { code: rawCode = '' } = useParams();
  const [params] = useSearchParams();
  const code = rawCode.trim().toUpperCase();
  const isValidCode = /^[A-Z0-9-]{2,64}$/.test(code);
  const isPhone = /Android|iPhone|iPad/.test(navigator.userAgent);
  const rawPlan = params.get('plan');
  const plan = rawPlan && /^[A-Za-z0-9_-]+$/.test(rawPlan) ? rawPlan : null;
  const yearly = params.get('yearly') === 'true';
  const { data, loading, error } = usePlansQuery({ skip: !isValidCode || !isPhone || !plan });
  const selectedPlan = plan && !loading && !error
    ? data?.plans?.find(candidate => candidate?.documentId === plan)
    : null;

  if (!isValidCode) return <Navigate to="/plans" replace />;

  const checkoutParams = new URLSearchParams({ coupon: code });
  const appParams = new URLSearchParams({ coupon: code });
  if (plan) appParams.set('plan', plan);
  if (yearly) {
    checkoutParams.set('yearly', 'true');
    appParams.set('yearly', '1');
  }
  const checkout = `${plan ? `/plans/${encodeURIComponent(plan)}` : '/plans'}?${checkoutParams}`;
  if (!isPhone) return <Navigate to={checkout} replace />;

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-gray-800 border-gray-700">
        <CardHeader className="text-center">
          <img src="/images/autoclipper-logo-full.png" alt="Autoclipper" className="h-12 w-auto mx-auto mb-4" />
          <CardTitle className="text-2xl text-white">{t('couponLanding.title')}</CardTitle>
          <CardDescription className="text-gray-400">{t('couponLanding.description')}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6 text-center">
          <div className="space-y-2">
            <p className="break-all text-2xl font-mono font-semibold text-green-400">{code}</p>
            {selectedPlan?.name && (
              <p className="text-sm text-gray-300">{selectedPlan.name} · {t(yearly ? 'pricing.yearly' : 'pricing.monthly')}</p>
            )}
          </div>
          <div className="flex flex-col gap-3">
            <Button asChild className="w-full"><a href={`autoclipper://plans?${appParams}`}>{t('couponLanding.openApp')}</a></Button>
            <Button asChild variant="outline" className="w-full"><Link to={checkout}>{t('couponLanding.continueWebsite')}</Link></Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CouponLanding;
